/**
 * Geteilter Zeitraum-Store (Zustand).
 *
 * Hält den aktuell betrachteten Monat als "YYYY-MM". Liste, Kalender und
 * Übersicht lesen daraus, statt jeweils eigenen lokalen State zu halten —
 * so bleibt der Monatswechsel über alle drei Ansichten synchron.
 *
 * Die Übersicht rechnet intern mit Abrechnungszyklen (billingCycleStartDay);
 * sie leitet ihren Zyklus aus `anchorMonth` ab und schreibt bei Navigation
 * den Monat zurück (siehe pages/OverviewPage.tsx).
 */

import { create } from 'zustand';
import { currentMonthKey, shiftMonthKey } from '../lib/month';

interface PeriodState {
  /** Aktuell betrachteter Monat, "YYYY-MM". */
  anchorMonth: string;
  setMonth: (key: string) => void;
  next: () => void;
  prev: () => void;
}

export const usePeriod = create<PeriodState>((set) => ({
  anchorMonth: currentMonthKey(),
  setMonth: (key) => set({ anchorMonth: key }),
  next: () => set((s) => ({ anchorMonth: shiftMonthKey(s.anchorMonth, +1) })),
  prev: () => set((s) => ({ anchorMonth: shiftMonthKey(s.anchorMonth, -1) })),
}));
